import React, { Component } from "react";
import { Formik, Form, Field } from "formik";
import { Button, Message } from "semantic-ui-react";
import { connect } from "react-redux";

import FormsInputsText from "../../inputs/text/forms_inputs_text";
import { resendAdminInvitation } from "../../../../actions";
import ResetPasswordEmailSchema from "./validate";

class FormsResetPasswordEmail extends Component {
  state = {
    success: false,
    error: false,
    errorMessage: "",
  };

  render() {
    if (this.state.success) {
      return (
        <Message positive>
          <Message.Header>Email sent</Message.Header>
          <p>A password setup link has been sent. Please check your email.</p>
        </Message>
      );
    }

    return (
      <Formik
        initialValues={{ email: "" }}
        onSubmit={(values, actions) => {
          this.setState({ error: false });

          this.props.resendAdminInvitation(
            { email: values.email },
            (status, error) => {
              actions.setSubmitting(false);

              if (error) {
                const errorMessage =
                  (error.response &&
                    error.response.data &&
                    error.response.data.errorMessage) ||
                  "Unable to send reset link. Please try again.";
                this.setState({ error: true, errorMessage });
              } else {
                this.setState({ success: true });
              }
            }
          );
        }}
        validationSchema={ResetPasswordEmailSchema}
        validateOnBlur={false}
        validateOnChange={false}
        render={({ isSubmitting }) => (
          <Form>
            <Field
              name="email"
              component={FormsInputsText}
              secondaryLabel="Email Address"
            />
            &nbsp;
            <Button
              type="submit"
              primary
              fluid
              loading={isSubmitting}
              disabled={isSubmitting}>
              Send Reset Password Link
            </Button>
            {this.state.error && (
              <Message negative>{this.state.errorMessage}</Message>
            )}
          </Form>
        )}
      />
    );
  }
}

export default connect(null, {
  resendAdminInvitation,
})(FormsResetPasswordEmail);
